import { isValidNumber } from 'libphonenumber-js'

const order = {
  delivery_times: null,
  name: '',
  phone: '+7',
  email: '',
  city: 'Белореченск',
  street: '',
  house: '',
  comment: '',
  street_kladr_id: '',
  delivery: true,
  dishes_orders_attributes: [],
}

export const validOrder = order => {
  let result = []
  const attribs = order.delivery ? ['name', 'city'] : ['name']
  attribs.forEach(attr => order[attr] === '' && result.push(attr))
  !(order.phone && isValidNumber(order.phone, 'RU')) && result.push('phone')
  order.delivery && !order.address.isValid && result.push('address')
  return result
}

export const createOrder = props => ({
  ...order,
  ...props
})



// WEBPACK FOOTER //
// ./src/features/OrderDetails/models/order.js